'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _pure = require('recompose/pure');

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = require('../../SvgIcon');

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MapsLocalCafe = function MapsLocalCafe(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M20 3H4v10c0 2.21 1.79 4 4 4h6c2.21 0 4-1.79 4-4v-3h2c1.11 0 2-.89 2-2V5c0-1.11-.89-2-2-2zm0 5h-2V5h2v3zM2 21h18v-2H2v2z' })
  );
};
MapsLocalCafe = (0, _pure2.default)(MapsLocalCafe);
MapsLocalCafe.displayName = 'MapsLocalCafe';
MapsLocalCafe.muiName = 'SvgIcon';

exports.default = MapsLocalCafe;


/*****************
 ** WEBPACK FOOTER
 ** ./~/material-ui/svg-icons/maps/local-cafe.js
 ** module id = 2196
 ** module chunks = 0
 **/